import { render, staticRenderFns } from "./OrderRefundForm.vue?vue&type=template&id=e20482ee&scoped=true"
import script from "./OrderRefundForm.vue?vue&type=script&lang=js"
export * from "./OrderRefundForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20482ee",
  null
  
)

export default component.exports